import { ReadConfigService } from './../../shared/services/common/read-config.service';
import { EmployeesService } from './../../shared/services/employees/employees.service';
import { DisplayNotificationService } from './../../shared/services/common/notification.service';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { Component, OnInit } from '@angular/core';
import { State } from '@progress/kendo-data-query';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cutoff-notices',
  templateUrl: './cutoff-notices.component.html',
  styleUrls: ['./cutoff-notices.component.css']
})
export class CutoffNoticesComponent implements OnInit {
  initialLoading = false;
  config: any;
  gridData = [];
  state: State = {
    skip: 0,
    take: 10,
    sort: []
  };

  constructor(
    private router: Router,
    private usersService: UsersService,
    private employeesService: EmployeesService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService
  ) { }

  ngOnInit(): void {
    this.config = this.readConfigService.getCutoffNoticesText();
    this.notificationService.setUpLoading(true);
    this.initialLoading = true;
    this.getCutoffData();
  }

  getCutoffData() {
    this.gridData = [];
    const inputData = { userInfo: this.usersService.UserInfo() };
    this.employeesService.getCutoffNoticesData(inputData).subscribe((response: any) => {
      if (response && response.statusCode === 200) {
        if(response.data && response.data.length > 0) {
          const cutoffData = response.data;
          cutoffData.forEach(element => {
            element.effectiveDate = new Date(element.effectiveDate);
            element.processDate = new Date(element.processDate);
          });
          this.gridData = cutoffData;
        } else {
          this.gridData = [];
        }
      } else if (response && response.statusCode === 204) {
        this.gridData = [];
      } else if (response && response.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.initialLoading = false;
      this.notificationService.setUpLoading(false);
    },
    (err: HttpErrorResponse) => {
      console.log(err);
      this.notificationService.setUpLoading(false);
      this.initialLoading = false;
      this.notificationService.setErrorNotification();
    });
  }

}
